import PropTypes from 'prop-types';

export const notificationType = PropTypes.shape({
    id: PropTypes.number.isRequired,
    message: PropTypes.string.isRequired,
    type: PropTypes.oneOf([
        'success',
        'error',
        'info',
        'warning',
    ]).isRequired,
});
